import { $http } from '@/common/api/http.service';

// Ratings and link clicks on Lens Help answers (#6535) — LensHelpFeedbackController. Background
// calls: the caller shows its own message, so the global error snackbar is skipped.
const turnPath = (accountId, turnId) => `/api/account/${encodeURIComponent(accountId)}/lens/turns/${encodeURIComponent(turnId)}`;
const background = (config) => ({ errorHandle: false, ...config });

export default {
    // rating: 'up' | 'down'; reason (down only): 'wrong_guide' | 'not_answered' | 'out_of_date' | 'other'
    rate: (accountId, turnId, rating, reason, config) => $http.put(`${turnPath(accountId, turnId)}/rating`, reason ? { rating, reason } : { rating }, background(config)),
    clearRating: (accountId, turnId, config) => $http.delete(`${turnPath(accountId, turnId)}/rating`, background(config)),
    // target: a guide id, or { route } for a screen link sent with that answer (#6544).
    click: (accountId, turnId, target, config) =>
        $http.post(`${turnPath(accountId, turnId)}/click`, typeof target === 'object' && target !== null ? { route: target.route } : { guideId: target }, background(config)),
};
